<script>
import { getOneWRPById, updateOneWRPProp, deleteOneWRP } from '@/services/WeeklyReviewPreviewServices';
import StackedGraphics from '@/pages/wrp/components/StackedGraphics.vue';
import CalWeekPreview from '@/pages/wrp/components/CalWeekPreview.vue';
import CalWeekReview from '@/pages/wrp/components/CalWeekReview.vue';

export default {
  components: {
    CalWeekReview,
    CalWeekPreview,
    StackedGraphics
  },
  props: ['id'],
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      loading: true,
      //
      wrp: null,
      // MODAL - EDIT A WRP PROP
      showEditPropModal: false,
      showEditPropLoading: false,
      editPropTitlesObj: {
        unexpectedObstacles: 'Unexpected Obstacles You Faced This Past Week',
        whatWorkedForYou: 'What Worked / Helped?',
        whatWouldYouDoDifferently: 'What Would You Do Better / Differently Net Time?',
        mainTargetForUpcomingWeek: 'Main Target / Goal for the Upcoming Week',
      },
      editPropId: '',
      editPropTitle: '',
      editPropText: '',
    };
  },
  methods: {
    // async getTheWRP() {
    //   const what = await getOneWRPById(this.uId, this.token, this.id);
    //   if (what) {
    //     this.wrp = what;
    //   }
    // },
    async openEditPropModal(prop) {
      console.log('*** starting openEditPropModal() ***', prop);
      this.editPropId = prop;
      this.editPropTitle = this.editPropTitlesObj[prop];
      this.editPropText = this.wrp[prop];
      await this.$nextTick();

      this.showEditPropModal = true;
    },
    async closeEditPropModal() {
      console.log('*** starting closeEditModal() ***');
      this.showEditPropModal = false;
      await this.$nextTick();
      // reset editPropModal
      this.editPropId = this.editPropTitle = this.editPropText = '';
    },
    async updateProp() {
      console.log('*** starting updateProp() ***');
      this.showEditPropLoading = true;

      const newText = this.editPropText.trim();
      const successfullyUpdatedAProp = await updateOneWRPProp(this.uId, this.token, this.id, this.editPropId, newText);
      if (successfullyUpdatedAProp) {
        this.wrp[this.editPropId] = this.editPropText.trim();
        this.showEditPropLoading = false;
        await this.$nextTick();

        this.showEditPropModal = false;
        await this.$nextTick();

        this.editPropId = this.editPropTitle = this.editPropText = '';
      }

    },
    async deleteThisWholeWRP() {
      console.log('*** starting deleteThisWholeWRP() ***');

      await deleteOneWRP(this.uId, this.token, this.id);
      await this.$nextTick();

      window.location.href = '/wrp/all';
      // this.$router.push('/wrp/all');
    },
  },
  async created() {
    console.clear();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    // console.log('***** prop id *****', this.id);
    // await this.getTheWRP();
    const what = await getOneWRPById(this.uId, this.token, this.id);
    if (what) {
      this.wrp = what;
      console.log('**** wrp ******', this.wrp);
      this.loading = false;
    }

  },
}
</script>

<template>
<div v-if="loading">
  <v-progress-circular color="green-lighten-3" indeterminate></v-progress-circular>
</div>
<div v-else id="page-wrp-one" class="py-4 px-4">
  <h1>Archive > One WRP</h1>

  <!-- STEP 0: Dates -->
  <p class="mt-4 mb-16 d-flex justify-space-between">
    <b>Date of Review:</b> <u>{{wrp?.dateOfReview.display}}</u>
  </p>
  <div class="my-4">
    <p><b>Review the Week of:</b></p>
    <CalWeekReview :weekToReview="wrp?.weekToReview" />
  </div>
  <div class="my-4">
    <p><b>Preview the Week of:</b></p>
    <CalWeekPreview :weekToPreview="wrp?.weekToPreview" />
  </div>

  <!-- STEP 1: REVIEW - Last Week's Targets -->
  <h3 class="mt-16"><b><u>Step 1 - Did You Hit Your Target(s) Last Week?</u></b></h3>
  <p class="my-8 wrp-pre-line">
    <b>Main Target/Goals for This Past Week:</b><br />
    {{wrp?.targetForThisPastWeek}}
  </p>
  <p class="my-8">
    <b>Did You Hit Your Target/Goals this Past Week:</b><br />
    <span v-if="wrp?.hitThisPastWeekTarget === '1'">YES</span>
    <span v-else>No</span>
  </p>

  <!-- STEP 2: REVIEW Last Week's Data & Self-Evaluation -->
  <h3 class="mt-16 pt-16"><b><u>Step 2 - Self-Review the Past Week</u></b></h3>
  <!-- Wins Stacked Count, StackedGraphics -->
  <div class="my-8">
    <p class="mb-2"><b>How Many Wins You STACKED This Week</b></p>
    <StackedGraphics
        :stackedWins="wrp?.stackedWins" :totalPossibleWins="wrp?.totalPossibleWins"
        :stackedBigTasks="wrp?.stackedBigTasks" :totalPossibleBigTasks="wrp?.totalPossibleBigTasks"
        :stackedSmallTasks="wrp?.stackedSmallTasks" :totalPossibleSmallTasks="wrp?.totalPossibleSmallTasks"
    />
  </div>
  <!-- Rate Your Performance -->
  <div class="my-8">
    <p class="mb-2"><b>Rate Your Performance This Past Week</b></p>
    <div class="px-8 d-flex justify-space-between">
      <div v-for="i in 5" :key="i" class="d-flex flex-column align-center justify-start">
        <v-icon
          :icon="wrp?.rateYourPerformance >= i ? 'mdi-arm-flex' : 'mdi-arm-flex-outline'"
          :color="wrp?.rateYourPerformance >= i ? 'yellow-darken-2' : 'grey-lighten-1'"
        ></v-icon>
        <p v-if="wrp?.rateYourPerformanceDescriptions" class="text-wrap">{{ wrp?.rateYourPerformanceDescriptions[i] }}</p>
      </div>
    </div>
  </div>
  <!-- Unexpected Obstacles -->
  <div class="my-8">
    <div class="d-flex justify-space-between">
      <p><b>Unexpected Obstacles You Faced This Past Week</b></p>
      <v-btn @click.prevent="openEditPropModal('unexpectedObstacles')"
             variant="text"
             density="compact"
             color="text-lowercase text-red-lighten-2 font-italic"
      >edit</v-btn>
    </div>
    <p class="wrp-pre-line">{{wrp?.unexpectedObstacles}}</p>
  </div>
  <!-- What Worked/Helped -->
  <div class="my-8">
    <div class="d-flex justify-space-between">
      <p><b>What Worked / Helped?</b></p>
      <v-btn @click.prevent="openEditPropModal('whatWorkedForYou')"
             variant="text"
             density="compact"
             color="text-lowercase text-red-lighten-2 font-italic"
      >edit</v-btn>
    </div>
    <p class="wrp-pre-line">{{wrp?.whatWorkedForYou}}</p>
  </div>
  <!-- What Would You Do Differently? -->
  <div class="my-8">
    <div class="d-flex justify-space-between">
      <p><b>What Would You Do Better / Differently Next Time?</b></p>
      <v-btn @click.prevent="openEditPropModal('whatWouldYouDoDifferently')"
             variant="text"
             density="compact"
             color="text-lowercase text-red-lighten-2 font-italic"
      >edit</v-btn>
    </div>
    <p class="wrp-pre-line">{{wrp?.whatWouldYouDoDifferently}}</p>
  </div>


  <!-- STEP 3: PREVIEW Upcoming Week's Events -->
  <h3 class="mt-16 pt-16"><b><u>Step 3 - Preview the Upcoming Week</u></b></h3>
  <!-- Events Added -->
  <div class="my-8">
    <p class="mb-2"><b>Events Added to This Upcoming Week</b></p>

    <div v-if="wrp?.newTasksAddedToUpcomingWeek">
      <ul class="ms-4 mb-6">
        <li class="">{{wrp?.addBirthdayCount}} Birthdays</li>
        <li class="">{{wrp?.addPersonalCount}} Personal / Social Events</li>
        <li class="">{{wrp?.addMainTaskCount}} Daily Main Goals</li>
      </ul>
      <div v-for="d in Object.keys(wrp?.newTasksAddedToUpcomingWeek)" :key="d"
           class="mt-2"
      >
        <p class="mt-2"><u>{{ d }}</u></p>
        <ul class="ms-4">
          <li v-for="(thing, i) in wrp?.newTasksAddedToUpcomingWeek[d]" :key="i">{{ thing }}</li>
        </ul>
      </div>
    </div>
    <div v-else>
      <p>N/A</p>
    </div>

  </div>
  <!-- Did you Timeblock Your Days? -->
  <div class="my-8">
    <p class="mb-2"><b>Days Are Time-Blocked</b></p>
    <p>{{ wrp?.finishedTimeBlocking ? 'Yes' : 'No' }}</p>
  </div>


  <!-- STEP 4: MAIN TARGET/Goals for Upcoming Week -->
  <h3 class="mt-16 pt-16"><b><u>Step 4 - Set the Target for the Upcoming Week</u></b></h3>
  <div class="my-8">
    <div class="d-flex justify-space-between">
      <p class="mb-2"><b>Main Target / Goal for the Upcoming Week</b></p>
      <v-btn @click.prevent="openEditPropModal('mainTargetForUpcomingWeek')"
             variant="text"
             density="compact"
             color="text-lowercase text-red-lighten-2 font-italic"
      >edit</v-btn>
    </div>
    <p class="wrp-pre-line">{{wrp?.mainTargetForUpcomingWeek}}</p>
  </div>



  <!-- button to go back -->
  <div class="my-16 pt-16 d-flex flex-column align-start">
    <a href="/wrp/all" class="mb-12">
      <v-btn size="small" color="green-lighten-2"><b>Go Back to All WRP's</b></v-btn>
    </a>

    <v-btn @click.prevent="deleteThisWholeWRP"
           variant="outlined"
           color="red-lighten-1"
           size="small"
           class="font-italic text-body-2 font-weight-bold"
    >Delete this WRP</v-btn>
  </div>




  <!-- MODAL: edit parts of the WRP -->
  <v-dialog v-model="showEditPropModal" fullscreen>
    <v-card>
      <v-toolbar>
        <v-btn @click.prevent="closeEditPropModal" icon="mdi-close"></v-btn>
        <h2>Update an entry</h2>
      </v-toolbar>


      <div v-if="showEditPropLoading" class="d-flex justify-center py-8">
        <v-progress-circular indeterminate color="green" :size="42"></v-progress-circular>
      </div>

      <div v-else class="px-4 py-8">
        <h3 class="mb-4">{{ this.editPropTitle }}</h3>


        <v-textarea v-model="editPropText"
                    variant="outlined"
                    rows="2" auto-grow
        ></v-textarea>

        <div class="my-4 d-flex justify-space-between align-center">
          <v-btn @click.prevent="closeEditPropModal"
                 variant="outlined"
                 color="red-lighten-1"
                 density="comfortable"
                 class="text-capitalize font-italic"
          >Cancel</v-btn>
          <v-btn @click.prevent="updateProp"
                 class="text-capitalize"
                 color="green-lighten-1"
          >Save Changes</v-btn>
        </div>
      </div>

    </v-card>
  </v-dialog>

</div>
</template>

<style scoped lang="scss">
$preview-task-min-width: 240px;
#page-wrp-one {

  @media screen and (min-width: 768px) {
    padding-left: 0;
    padding-right: 0;
    margin: 0 auto;
    width: 600px;
    max-width: 600px;
  }

  .wrp-pre-line { white-space: pre-line; }

  // step 3
  .preview-ul-tasks {
    min-width: $preview-task-min-width;
  }
}
</style>
